import BaseModel from '@/orm/models/BaseModel';

export default class Plan extends BaseModel {
  static entity = 'plans';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(null),
      description: this.string(null),
      quotas: this.attr(null),
      price: this.attr(null),
      active: this.boolean(false),
      next: this.boolean(false),
      multiuserMode: this.attr(null),
      careerPortal: this.attr(null),
      aiRating: this.attr(null),
      aiReview: this.attr(null),
      aiInterview: this.attr(null),
      maximumAiQuestions: this.attr(null),
      maximumVacancies: this.attr(null),
      transcription: this.boolean(false),
      mailTemplate: this.boolean(false),
    };
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get('accounting/plans');
      },
    },
  }
}
